import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';

import {
  AbandonedSessionRecoveryService,
  AbandonedSessionReviewItem,
} from '../../_service/abandoned-session-recovery.service';

@Component({
  selector: 'app-abandoned-session-recovery',
  standalone: true,
  imports: [CommonModule, DialogModule, ButtonModule],
  templateUrl: './abandoned-session-recovery.component.html',
})
export class AbandonedSessionRecoveryComponent {
  items$: Observable<AbandonedSessionReviewItem[]>;

  constructor(private recoveryService: AbandonedSessionRecoveryService) {
    this.items$ = this.recoveryService.reviewItems$;
  }

  formatDate(iso: string): string {
    try {
      return new Date(iso).toLocaleString();
    } catch {
      return iso;
    }
  }

  keepCurrent(item: AbandonedSessionReviewItem): void {
    void this.recoveryService.keepCurrentAndRemove(item);
  }

  restore(item: AbandonedSessionReviewItem): void {
    void this.recoveryService.restoreOpeningVersion(item);
  }

  reviewLater(item: AbandonedSessionReviewItem): void {
    this.recoveryService.reviewLater(item);
  }
}
